<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fX0Pl0/tc-custom/9781460316085.jpg?1700369478349" alt="This image is the cover for the book Secret Agent Minister & Deadly Texas Rose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Agent Minister & Deadly Texas Rose
      </h1>
      <p class="bookDescription body article font2">
        <b>SECRET AGENT MINISTER</b><br/><br/>Small-town church secretary Lydia Cantrell has loved her boss, handsome pastor Devon Malone, from afar for years. But her feelings are put to the test when murderand his past as a Christian secret agentshake her faith.<br/><br/><b>DEADLY TEXAS ROSE</b><br/><br/>How much did a little girl see and hear of her secretive father’s murder? No one knows. So widow Julia Daniels takes her silent daughter and flees to the tiny Texas town of Wildflower. Sheriff Eric Butler makes her feel safeuntil danger trails her.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lenora Worth
      </h2>
      
      <p class="authorDescription body article">Lenora Worth writes for&#160;Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and&#160;a <I>New York Times</I>, <I>USA Today</I>, and <I>PW</I> bestselling author. She&#160;writes Southern stories set in places she loves such as Georgia, Texas, &#160;Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8478aec0